<template>
  <classroom-schedule-detail
    :schedule="schedule.data"
  ></classroom-schedule-detail>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import ClassroomScheduleDetail from '@components/ClassroomSchedule/Detail.vue'
export default {
  name: 'TeacherClassroomScheduleDetail',
  components: {
    ClassroomScheduleDetail,
  },
  layout: LayoutDashboard,
  props: {
    schedule: {
      type: Object,
      required: true,
    },
  },
}
</script>
